export interface GoogleIdTokenClaims {
  email?: string;
  name?: string;
}

export function parseGoogleIdToken(idToken: string): GoogleIdTokenClaims {
  const segments = idToken.split('.');
  if (segments.length < 2) {
    return {};
  }

  try {
    const payload = segments[1]
      .replace(/-/g, '+')
      .replace(/_/g, '/');
    const decoded = JSON.parse(atob(payload)) as GoogleIdTokenClaims;
    return {
      email: typeof decoded.email === 'string' ? decoded.email : undefined,
      name: typeof decoded.name === 'string' ? decoded.name : undefined,
    };
  } catch {
    return {};
  }
}
